
    import { Prop, PropSync, Component, Vue, Watch } from "vue-property-decorator";
    import { mixins } from "vue-class-component";
    import { FormModel, Modal, Row, Col, Tree } from "ant-design-vue";
    import { ProductsStockMix } from "@/UI/mixins/Store/ProductsStockMix";
    //import StaffUpdateForm from "@/form/staff/StaffUpdate";
    @Component({
        components: {
            "a-row": Row,
            "a-col": Col,
            "a-modal": Modal,
            "a-form-model-item": FormModel.Item,
            "a-form-model": FormModel,
            "a-tree": Tree,
        },
    })
    export default class StockProductsDialog extends mixins(ProductsStockMix) {
        @Prop() readonly modalTitle!: string;
        //@Prop() form!: StaffUpdateForm;

        async created(): Promise<void> {
            try {

            } catch (e) {
                console.log();
            }

        }

        onSelect(selectedKeys: any, info: any) {
            console.log("selected", selectedKeys, info);
        }

        onCheck(checkedKeys: any, info: any) {
            console.log("onCheck", checkedKeys, info);
        }
    }
